import Config           from '../../common/model/Config'
import { webAccess }    from '../../common/controller/webAccessibilityCtrl';
import { textFileGet }  from "../../common/utils/ajax";
import { device }       from '../../common/utils/deviceCheck';
import {helper}         from '../utils/handlebars.custom.helper';

var rootId = "";
export const template = {
    main_template: ()=>{
        rootId = Config.appendElementTagId;
        helper.init()
        var tmpl = require('../html/mainTemplate.hbs');
        var html = tmpl();
        $(`${rootId}`).html(html);
    },
    header : (json)=>{
        var tmpl = require('../html/header.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents header`).html(html);
    },
    form_inputinfo : (json)=>{
        var tmpl = require('../html/form.inputinfo.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents .pcView form`).html(html);
    },
    agree : (json)=>{
        var tmpl = require('../html/agree.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents .pcView form dl.agree`).html(html);
        const li = $("#oacxEmbededContents .agree li");
        $(li).length == 1 ? $(li).css("width","100%") : false;
    },
    mobile_select_service : ()=>{
        var tmpl = require('../html/mobile.select.service.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents .mobileView`).html(html);
    },
    mobile_select_service_toolbar: ()=>{
        var tmpl = require('../html/mobile.serviceSelectToolbar.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents .selectedService`).html(html);
    },
    mobile_popup_agree : (json)=>{
        var tmpl = require('../html/mobile.popup.agree.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents .mobileView .mAgreeBg`).html(html);
    },
    mobile_providerInfo : (json)=>{
        var tmpl = require('../html/mobile.providerInfo.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents .mobileView .oacx_providerList`).html(html);
    },
    mobile_form_inputInfo: (json)=>{
        var tmpl = require('../html/mobile.form.inputinfo.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents .mobileView form`).html(html);
    },
    popup_other_service : ()=>{
        var tmpl = require('../html/popup.other.service.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #view_otherSrv`).html(html);
    },
    popup_policy1 : (path)=>{
        textFileGet(path).then(res=>{
            $(`${rootId} #oacxEmbededContents #view_policy1`).html(res);
            $(`${rootId} #view_policy1 button`).on('click',(e)=>{
                $(`${rootId} .viewPop.view`).removeClass("view");
                if(device.isMobileUI()){
                    webAccess.targetFocus(`${rootId} #m_policy1_btn`);
                }else{
                    webAccess.targetFocus(`${rootId} #policy1_btn`);
                }
            })
        },res=>{});
    },
    popup_policy2 : (path)=>{
        textFileGet(path).then(res=>{
            $(`${rootId} #oacxEmbededContents #view_policy2`).html(res);
            $(`${rootId} #view_policy2 button`).on('click',(e)=>{
                $(`${rootId} .viewPop.view`).removeClass("view");
                if(device.isMobileUI()){
                    webAccess.targetFocus(`${rootId} #m_policy2_btn`);
                }else{
                    webAccess.targetFocus(`${rootId} #policy2_btn`);
                }
            })
        },res=>{});
    },
    popup_policy3 : (path)=>{
        textFileGet(path).then(res=>{
            $(`${rootId} #oacxEmbededContents #view_policy3`).html(res);
            $(`${rootId} #view_policy3 button`).on('click',(e)=>{
                $(`${rootId} .viewPop.view`).removeClass("view");
                if(device.isMobileUI()){
                    webAccess.targetFocus(`${rootId} #m_policy3_btn`);
                }else{
                    webAccess.targetFocus(`${rootId} #policy3_btn`);
                }
            })
        },res=>{});
    },
    popup_policy4 : (path)=>{
        textFileGet(path).then(res=>{
            $(`${rootId} #oacxEmbededContents #view_policy4`).html(res);
            $(`${rootId} #view_policy4 button`).on('click',(e)=>{
                $(`${rootId} .viewPop.view`).removeClass("view");
                if(device.isMobileUI()){
                    webAccess.targetFocus(`${rootId} #m_policy4_btn`);
                }else{
                    webAccess.targetFocus(`${rootId} #policy4_btn`);
                }
            })
        },res=>{});
    },
    popup_valid_warring : (json)=>{
        var tmpl = require('../html/popup.valid.warring.hbs');
        var html = tmpl(json);
        $(`${rootId} #oacxEmbededContents #view_err`).html(html);
    },
    standby : ()=>{
        var tmpl = require('../html/standby.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents .standby`).html(html);

        $("#oacxEmbededContents #naverStandbyStep").on('click',(e)=>{
            $(`${rootId} #view_standby`).addClass("view");
            webAccess.targetFocus(`#oacxEmbededContents #view_standby .alert`);
        })
    },
    popup_naver_standby_step : ()=>{
        var tmpl = require('../html/popup.naver.standby.step.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #view_standby`).html(html);
        $(`${rootId} #oacxEmbededContents #view_standby button`).on('click',(e)=>{
            webAccess.targetFocus(`#oacxEmbededContents #naverStandbyStep`)
        })
    },
    popup_incomplaete : ()=>{
        var tmpl = require('../html/popup.incomplete.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #auth_incomplete_alertArea`).html(html);
    },
    popup_unknown : ()=>{
        var tmpl = require('../html/popup.unknown.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #user_unknown_alertArea`).html(html);
    },
    popup_failure_service : ()=>{
        var tmpl = require('../html/popup.failure.service.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #auth_failure_alertArea`).html(html);
    },
    popup_inactive_service : ()=>{
        var tmpl = require('../html/popup.inactive.service.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #inactive_service_provider_alertArea`).html(html);
    },
    popup_failure_system : ()=>{
        var tmpl = require('../html/popup.failure.system.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #system_failure_alertArea`).html(html);
    },
    popup_failure_client : ()=>{
        var tmpl = require('../html/popup.failure.client.hbs');
        var html = tmpl();
        $(`${rootId} #oacxEmbededContents #client_failure_alertArea`).html(html);
    },
    providerInfo: (json)=>{
        var tmpl = require('../html/providerInfo.hbs');
        var html = tmpl(json);
        $(`${rootId} .pcView .oacx_providerList`).html(html)
    } 
}
